import styled from "@emotion/styled";

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
`;

export const LoadingContainer = styled.div`
    padding: 16px 24px;
    background: #23252a;
    border-radius: 16px;
    outline: 1px #2b2d33 solid;
    outline-offset: -1px;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    display: inline-flex;
`;

export const LoadingText = styled.span`
    color: #b7bdcb;
    font-size: 16px;
    font-family: Inter;
    font-weight: 500;
    line-height: 120%;
    word-wrap: break-word;
`;

export const ErrorContainer = styled.div`
    padding: 8px 12px;
    opacity: 0.90;
    background: #d65f46;
    border-radius: 999px;
    justify-content: center;
    align-items: center;
    display: inline-flex;
`;

export const ErrorText = styled.span`
    color: #e9ecf5;
    font-size: 13px;
    font-family: Inter;
    font-weight: 500;
    line-height: 18.20px;
    word-wrap: break-word;
`;

export const SuccessContainer = styled.div`
    padding: 8px 24px;
    background: #5e84ed;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.10);
    overflow: hidden;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    display: inline-flex;
`;

export const SuccessText = styled.span`
    color: #e9ecf5;
    font-size: 15px;
    font-family: Inter;
    font-weight: 500;
    line-height: 20px;
    word-wrap: break-word;
`;
